export default "__VITE_ASSET__B1898ZkP__"